// This file is automatically generated. Do not edit manually.

import { PurchaseOrderCustomerOrderView } from "src/api/generated/erp/db/types/tables/purchaseOrderCustomerOrderView";
import { CreatePurchaseOrderRequest } from "src/api/generated/erp/purchase/purchaseOrder/service/createPurchaseOrderRequest";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PurchaseOrderCustomerOrdersApi {
	export async function getPurchaseOrdersForCustomerOrder(args: {
		customerOrderId: number;
	}): Promise<Array<PurchaseOrderCustomerOrderView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/customerOrders/getPurchaseOrdersForCustomerOrder",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
			},
		});
		return response as Array<PurchaseOrderCustomerOrderView>;
	}

	export async function getCustomerOrdersForPurchaseOrder(args: {
		purchaseOrderId: number;
	}): Promise<Array<PurchaseOrderCustomerOrderView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/customerOrders/getCustomerOrdersForPurchaseOrder",
			method: "POST",
			data: {
				purchaseOrderId: args.purchaseOrderId,
			},
		});
		return response as Array<PurchaseOrderCustomerOrderView>;
	}

	export async function connectPurchaseOrderToCustomerOrder(args: {
		purchaseOrderId: number;
		customerOrderId: number;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/customerOrders/connectPurchaseOrderToCustomerOrder",
			method: "POST",
			data: {
				purchaseOrderId: args.purchaseOrderId,
				customerOrderId: args.customerOrderId,
			},
		});
		return response as number;
	}

	export async function disconnectPurchaseOrderFromCustomerOrder(args: {
		purchaseOrderCustomerOrderId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/customerOrders/disconnectPurchaseOrderFromCustomerOrder",
			method: "POST",
			data: {
				purchaseOrderCustomerOrderId: args.purchaseOrderCustomerOrderId,
			},
		});
		return response as void;
	}

	export async function createPurchaseOrderForCustomerOrder(args: {
		request: CreatePurchaseOrderRequest;
		customerOrderId: number;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/customerOrders/createPurchaseOrderForCustomerOrder",
			method: "POST",
			data: {
				request: args.request,
				customerOrderId: args.customerOrderId,
			},
		});
		return response as number;
	}
}
